module.exports = __webpack_public_path__ + "static/media/left_color.f62c6ac5.png";